<div *ngIf="mappedData; else loading">
  <div class="table-head clearfix">
    <div class="table-col c-image"></div>
    <div class="table-col c-notes"></div>
    <div class="table-col c-qty">
      <b *ngIf="!isUser" translate>QUANTITY</b>
      <b *ngIf="isUser" translate>REQUESTED_QUANTITY</b>
    </div>
    <div class="table-col c-availability">
      <b translate>AVAILABILITY</b>
    </div>
    <div class="table-col c-price">
      <b *ngIf="!isUser" translate>PRICE</b>
      <b *ngIf="isUser" translate>UNIT_PRICE</b>
    </div>
    <div class="table-col c-discount" *ngIf="!isUser">
      <b translate>DISCOUNT_PERCENT</b>
    </div>
    <div class="table-col c-total">
      <b translate>TOTAL</b>
    </div>
    <div class="table-col c-delivery">
      <b translate>DELIVERY</b>
    </div>
    <div class="table-col c-options"></div>
  </div>
  <div class="table-body">
    <div class="table-line clearfix" *ngFor="let row of mappedData; index as index; trackBy: trackByFn">
      <div class="product-name" style="font-size: 1rem">
        <div
          [routerLink]="[
            row.product.extra.assortmentParentPath ? '/articles/' + row.product.extra.assortmentParentPath : '/product/',
            row.product.id
          ]"
        >
          <b>{{ row.product.id }}</b> - {{ row.product | productName }}
        </div>
        <div class="d-block">
          <b
            *ngIf="
              selectedCustomer &&
              row.product.extra._customerCrossReferences &&
              row.product.extra._customerCrossReferences[selectedCustomer.id]
            "
            class="small"
          >
            {{ row.product.extra._customerCrossReferences[selectedCustomer.id].referenceId }}
          </b>
          <a class="ml-2" (click)="openCrossReferenceEditor(row)">
            <i class="fas fa-edit"></i>
          </a>
        </div>
        {{
          row.product.description.length > 40 ? (row.product.description | slice: 0:40) + '..' : row.product.description
        }}
      </div>
      <div class="line-cols">
        <div
          class="table-col c-image navigate-to-product-details"
          [routerLink]="[
            row.product.extra.assortmentParentPath ? '/articles/' + row.product.extra.assortmentParentPath : '/product/',
            row.product.id
          ]"
        >
          <img
            class="img-fluid"
            src="https://cdn1.gung.io/fit-in/64x64/filters:fill(white):background_color(white):format(jpeg)/{{
              row.product.extra.images[0].s3Uri
            }}"
            alt=""
          />
        </div>

        <div class="table-col c-notes navigate-to-product-details">
          <button class="btn btn-primary btn-sm" (click)="editNote(row.cartRow)">
            <span translate style="font-size: 1rem">NOTES</span>
          </button>
        </div>

        <div class="table-col c-qty">
          <b translate class="mobile-label">QUANTITY</b>
          <div
            *ngIf="
              isAnonymous ||
                (!(
                  row.product.extra.pim &&
                  row.product.extra.pim.pricerequest &&
                  row.product.extra.pim.pricerequest !== 'false'
                ) &&
                  !(row.product.extra.ar.itemtypecd1 === 0 || row.product.extra.ar.itemtypecd1 === 7 || (row.product.extra.ar.itemtypecd1 === 6 && row.cartRow?.extra?._availability_reference?.currentAvailability <= 0)));
              else priceRequest
            "
            class="d-flex align-items-center"
          >
            <otto-olsen-buy-btn
              name="buy-btn-package-size"
              [id]="row.product.id"
              [checkoutCart]="true"
              [minimumOrderQuantity]="row.product?.firstStepAmount || row.product?.packageSize"
              [stepAmount]="row.product?.packageSize"
              [decimals]="row.product?.extra.ar.antdec"
              [activeInB2B]="row?.product?.extra?.pim?.activeInB2B"
            >
            </otto-olsen-buy-btn>
            <span class="pl-1">
              {{ row.product.extra.ar?.enhetskod }}
            </span>
          </div>
          <ng-template #priceRequest>
            <a
              href="mailto:{{ requestPriceEmail }}?subject=Forespørsel {{ row.product.id }}"
              target="_blank"
              class="request-price-email"
            >
              <button type="button" class="btn btn-primary" translate>ASK_PRICE</button>
            </a>
          </ng-template>
        </div>

        <div class="table-col c-availability">
          <b translate class="mobile-label">AVAILABILITY</b>
          <otto-olsen-availability
            [availability]="row.cartRow?.extra?._availability_reference"
            [unit]="row.product?.extra.ar?.enhetskod"
            [decimals]="row.product?.extra.ar.antdec"
            [productionDays]="row.product?.extra.ar?.anskaffningssatt && (row.product?.extra.ar?.anskaffningssatt * 1) === 12 && row.product?.extra.ar?.artgenomloppstid"
          ></otto-olsen-availability>
        </div>

        <div class="table-col c-price">
          <ng-container *ngIf="!isUser">
            <b translate class="mobile-label">PRICE</b>
            <input
              type="number"
              class="form-control text-right px-1"
              [value]="parseFloatFixed(row.overridePrice, 2)"
              [placeholder]="row.originalPrice | number: '1.2-2'"
              (blur)="updateOverridePrice(row, parseFloatFixed($event.target.value, 2))"
            />
          </ng-container>
          <ng-container *ngIf="isUser">
            <b translate class="mobile-label">UNIT_PRICE</b>
            <b>
              <lib-price [price]="row.price.cartRowUnitPrice.value"></lib-price>
              <span *ngIf="row.price.cartRowDiscountPercent !== 0"
                >(-{{ parseFloatFixed(row.price.cartRowDiscountPercent, 2) }}%)</span
              >
            </b>
          </ng-container>
        </div>

        <div class="table-col c-discount" *ngIf="!isUser">
          <b translate class="mobile-label">DISCOUNT_PERCENT</b>
          <input
            type="number"
            class="form-control discount-control px-1"
            [value]="parseFloatFixed(row.discountPercent || row.cartRowPriceElement.cartRowDiscountPercent || 0, 2)"
            (blur)="updateDiscountPercentage(row, $event.target.value, true)"
            placeholder="%"
          />
        </div>

        <div class="table-col c-total">
          <ng-container *ngIf="!isUser">
            <b translate class="mobile-label">TOTAL</b>
            <lib-price [price]="row.price.cartRowTotalPriceInclRowDiscount.value"></lib-price>
          </ng-container>
          <ng-container *ngIf="isUser">
            <b translate class="mobile-label">TOTAL_PRICE</b>
            <lib-price [price]="row.price.cartRowTotalPriceInclRowDiscount.value"></lib-price>
          </ng-container>
        </div>

        <div class="table-col c-delivery">
          <b translate class="mobile-label">DELIVERY</b>
          <div class="fit-datepicker">
            <div *ngIf="!partDeliveriesForbidden">
              <lib-delivery-date-picker
                *ngIf="row.minDate"
                (selectedDate)="updateDeliveryDate(row, $event)"
                [initialDate]="row.deliveryDate ? row.deliveryDate : formatNgbDate(row.minDate)"
                [deliveryMethod]="selectedDeliveryMethod"
                [minInitialDate]="row.minDate"
                [label]="null"
              ></lib-delivery-date-picker>
            </div>
            <div *ngIf="partDeliveriesForbidden">
              <lib-delivery-date-picker
                *ngIf="selectedDeliveryDate"
                [initialDate]="selectedDeliveryDate"
                [currentselectedDate]="selectedDeliveryDate"
                [label]="null"
                [disabled]="true"
              ></lib-delivery-date-picker>
            </div>
          </div>
        </div>

        <div class="table-col c-options text-right clearfix">
          <ng-container *ngTemplateOutlet="rowBtns; context: { row }"></ng-container>
        </div>
      </div>
      <div class="d-block pt-2">
        <div
          *ngIf="row.cartRow.extra.warning && !warningWasActiveBefore[row.productId]"
          class="d-flex alert alert-danger p-1"
        >
          <span translate>DELIVERY_DATE_CHANGED_DUE_TO_STOCK</span>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #loading> LOADING <i class="fas fa-spinner fa-spin ml-2"></i> </ng-template>

<ng-template #rowBtns let-row="row">
  <button
    *ngIf="enableDuplicateRow"
    type="button"
    class="btn btn-secondary btn-sm mr-1"
    (click)="duplicateProduct(row, index)"
  >
    <i class="fas fa-copy fa-2x"></i>
  </button>
  <button class="btn btn-light delete-button" (click)="removeRow(row)">
    <i class="fas fa-trash-alt fa-2x"></i>
  </button>
  <button *ngIf="favouriteIcon" class="btn btn-light delete-button ml-2" (click)="favouriteIcon.toggle()">
    <i class="fa-star fa-2x" [ngClass]="favouriteIcon.isFavourite ? 'fas' : 'far'"></i>
  </button>
  <lib-favourite-product-icon #favouriteIcon [id]="row.product.id" class="d-none"></lib-favourite-product-icon>
</ng-template>
